// import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme'
//import * as c from "material-ui/utils/colorManipulator"
import * as colors from "material-ui/styles/colors"
import getMuiTheme from "material-ui/styles/getMuiTheme"

// http://www.material-ui.com/#/customization/themes
// https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js
export const theme = getMuiTheme({
  toolbar: {
    // this is also the text/title color
    iconColor: colors.blue100,
  },
  snackbar: {
    textColor: colors.white,
    backgroundColor: colors.purple800,
  },
  raisedButton: {
    disabledColor: colors.grey800,
    disabledTextColor: colors.grey600,
  },
  palette: {
    primary1Color: colors.purple900,
    primary2Color: colors.purple800,
    primary3Color: colors.purple800,
    accent1Color: colors.blue700,
    accent2Color: colors.blue800,
    accent3Color: colors.blue500,
    canvasColor: colors.grey900,
    disabledColor: colors.grey500,
    textColor: colors.white,
    alternateTextColor: colors.grey100,
  },
})



// WEBPACK FOOTER //
// ./src/app/Theme.js